<template>
  <div class="scroll-hide">
  <div class="privacy">
    <!-- <div class="header">
      <div class="title">个人信息保护咨询指引</div>
    </div> -->
    <div class="content">
        <div class="text">尊敬的用户：</div>
         <div class="text">您好，如您对本政策或相关事宜有任何问题，请您通过填写以下指引，将相关资料发送至{{ email }}或寄到如下地址：</div>
          <div class="text">地址：天津自贸试验区(空港经济区)环河北路与中心大道交口空港商务园东区2-1,2-201-1 技术保障部（收）</div>
          <div class="text">邮编：300308</div>
          <div class="text">我们将尽快处理。</div>
          <div class="bottom text">附录: <span class="herf" @click="toGuide()">《个人信息保护咨询指引》</span></div>

    </div>
  </div>
  </div>
</template>

<script>

export default {
  name: 'Privacy',
  data() {
    return {
      email: this.$config.env.VUE_APP_BRAND === "COTTI" ? 'privacy@cotticoffee.com' : 'privacy@teacat.com'
    }
  },
  methods: {
    toGuide () {
      this.$router.push({path: '/protectInformationGuide'})
    }
  }
}
</script>

<style scoped lang="scss">
.scroll-hide {
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
   background: #F5F5F5;
}
.privacy{
  padding: 32px;
  font-size: 24px;
  line-height: 40px;
  word-break: break-all;
  background: #F5F5F5;
  .bold{
    font-weight: bold !important;
    .child-herf {
      color: #346EF4;

    }
  }
  .title{
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 32px;
  }
  .header{
    font-weight: 500;
    color: #3A3B3C;
    border-bottom: 1px solid #eee;
    margin-bottom: 32px;
    line-height: 40px;
     .title{
    font-size: 42px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 32px;
  }
    .version{
       margin-bottom: 12px;
    }
    .updateTime{
       margin-bottom: 12px;
    }
    .effectiveTime{
       margin-bottom: 40px;
    }
  }
  .content{
    font-size: 24px;
    color: #3A3B3C;
    line-height: 48px;
    .herf {
      color: #346EF4;

    }
    .section{
      margin: 24px 0 16px 0;
      line-height: 48px;
      font-size: 28px;
      font-weight: 500;
    }
    .text{
      font-size: 24px;
      font-weight: 400;
    }
    .bottom {
        margin-top: 40px;
    }
  }
}
</style>
